import { Title, Text, Section as BaseSection } from '../../utils/theme';
import styled from 'styled-components';

export const Section = styled(BaseSection)`
  min-height: 0vh;
  position: relative;
  overflow: hidden;
  height: 90vw;

  @media (max-width: 1050px) {
    height: 95vw;
  }

  @media (max-width: 600px) {
    height: 310vw;
  }
`;

export const BackgroundVideo = styled.video`
  z-index: -1;
  position: absolute;
  top: 3vw;
  left: 0vw;
  width: 100vw;

  @media (max-width: 600px) {
    position: absolute;
    left: -58vw;
    top: 78vw;
    width: 200vw;
  }
`;

export const LandingTitle = styled(Title)`
  z-index: 3;
  position: absolute;
  top: 10vw;
  left: 5vw;
  font-size: 3.5vw;
  text-align: left;

  @media (max-width: 600px) {
    position: absolute;
    top: 20vw;
    left: 0vw;
    width: 100vw;
    font-size: 10vw;
    text-align: center;
  }
`;

export const LandingText = styled(Text)`
  z-index: 3;
  position: absolute;
  top: 16vw;
  left: 5vw;
  font-size: 1.25vw;
  text-align: left;
  line-height: 2;

  @media (max-width: 600px) {
    position: absolute;
    top: 37.5vw;
    left: 0vw;
    width: 100vw;
    font-size: 4vw;
    text-align: center;
    line-height: 2;
  }
`;

export const AnniversaryText = styled(Text)`
  z-index: 3;
  position: absolute;
  top: 65vw;
  left: 0vw;
  font-size: 2.5vw;
  text-align: center;
  width: 100vw;

  @media (max-width: 600px) {
    top: 200vw;
    font-size: 5vw;
  }
`;

export const StatisticsTextContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  top: 72vw;

  @media (max-width: 600px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    top: 227vw;
  }
`;

export const StatisticsText = styled(Text)`
  z-index: 3;
  font-size: 2.75vw;
  margin-left: 3vw;
  margin-right: 3vw;
  width: 15vw;
  text-align: center;
  line-height: 0.9;

  @media (max-width: 600px) {
    width: 50vw;
    font-size: 7vw;
  }
`;

export const ResponsiveSpan = styled.span`
  font-size: 1vw;

  @media (max-width: 600px) {
    font-size: 3.5vw;
  }
`;

export const StatisticsButtonContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: 85vw;

  @media (max-width: 600px) {
    top: 288vw;
  }
`;

export const StatisticsButton = styled.img`
  z-index: 3;
  width: 13vw;
  cursor: pointer;

  @media (max-width: 600px) {
    width: 35vw;
  }
`;

export const Countdown = styled.div`
  position: absolute;
  display: flex;
  justify-content: left;
  top: 22vw;
  left: 5vw;
  width: 20vw;
  margin: 1vw 0vw;

  @media (max-width: 600px) {
    position: absolute;
    display: flex;
    justify-content: center;
    top: 60vw;
    left: 25vw;
    width: 50vw;
  }
`